import { useCallback, useEffect, useState } from 'react';

import { useRouter, useSearchParams } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { ACCESS_TOKEN_KEY, getCookie, removeCookie } from 'src/services/cookies';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export const UserGuard = ({ children }: Props) => {
  const [checked, setChecked] = useState(false);

  const router = useRouter();

  // const [auth, setAuth] = useRecoilState(authStore);

  const searchParams = useSearchParams();

  const token = getCookie(ACCESS_TOKEN_KEY);

  const returnTo = searchParams.get('returnTo') || paths.auth.login;

  const check = useCallback(() => {
    if (!token) {
      removeCookie(ACCESS_TOKEN_KEY);
      // setAuth(DEFAULT_AUTH_STATE);
      router.replace(returnTo);
    } else {
      setChecked(true);
    }
  }, [returnTo, router, token]);

  useEffect(() => {
    check();
  }, [check]);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
};
